// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fade-enter-active,.fade-leave-active{transition-duration:.2s;transition-property:opacity,transform;transition-timing-function:cubic-bezier(0,0,.2,1)}.fade-enter-from,.fade-leave-to{opacity:0;transform:scaleX(1.05) scaleY(1.05)}.fade-enter-to,.fade-leave-from{opacity:1;transform:scaleX(1) scaleY(1)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
